import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../Table/ResultTable";
import ResultBody from "../../Table/ResultBody";
import ResultRow from "../../Table/ResultRow";
import EmptyLine from "../../EmptyLine";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultText from "../ResultText";
import ComparisonCSName from "../../ComparisonCSName";
import {useUser} from "../../../Context/UserContext";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ResultView from "../../V2/ResultView";
import StructureAssociateFootnote from "./StructureAssociateFootnote";

export function C5({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
            <StructureAssociateFootnote />
        </>
    )
}

const filterItem = ({name, base, compare}) => {
    if(!base && !compare)
        return false

    return true
}

const renderItem = ({name, base, compare}) => {
    if((!base && !compare) || (base === '*' && compare === '*'))
        return name
    else if(base && !compare)
        return `${name} (${base}/-)`
    else if(!base && compare)
        return `${name} (-/${compare})`

    if(Array.isArray(base))
        base = base.join(', ')

    if(Array.isArray(compare))
        compare = compare.join(', ')

    return `${name} (${base}/${compare})`
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.BMC001.error_id: {
            return (
                <>
                    {
                        row.data.map(x => (
                            <div>
                                {renderStructureDiff(x)}
                                <br />
                            </div>
                        ))
                    }
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

const renderStructureDiff = (row) => {
    const data = row.diffs;

    return (
        <>
            <ResultText>
                There are differences in the bridge modeling approach of the bridge at RS {<ComparisonCSName csName={row?.cross_section} />}:
                <EmptyLine />
            </ResultText>
            <ResultTable data={row}>
                <ResultBody>
                    {
                        data.map(r => {
                            return (
                                <>
                                    {
                                        (r.low_flow.length > 0) && (
                                            <ResultRow>
                                                <ResultHeaderCell rowSpan={4} style={{width: HecRasHelper.getWidth(10), textAlign: 'left'}}>{r.name}</ResultHeaderCell>
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(25)}}><b>Low Flow Methods</b></ResultBodyCell>
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(45)}}>{r.low_flow.filter(filterItem).map(renderItem).join(', ')}</ResultBodyCell>
                                            </ResultRow>
                                        )
                                    }
                                    {
                                        (r.low_flow_ws.length > 0) && (
                                            <ResultRow>
                                                {
                                                    r.low_flow.length === 0 && (<ResultHeaderCell rowSpan={4} style={{width: HecRasHelper.getWidth(10), textAlign: 'left'}}>{r.name}</ResultHeaderCell>)
                                                }
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(25) }}><b>Low Flow Methods WS Pro</b></ResultBodyCell>
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(45)}}>{r.low_flow_ws.filter(filterItem).map(renderItem).join(', ')}</ResultBodyCell>
                                            </ResultRow>
                                        )
                                    }
                                    {
                                        (r.high_flow.length > 0) && (
                                            <ResultRow>
                                                {
                                                    r.low_flow.length === 0 && r.low_flow_ws === 0 && (<ResultHeaderCell rowSpan={4} style={{width: HecRasHelper.getWidth(10), textAlign: 'left'}}>{r.name}</ResultHeaderCell>)
                                                }
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(25)}}><b>High Flow Methods</b></ResultBodyCell>
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(45)}}>{r.high_flow.filter(filterItem).map(renderItem).join(', ')}</ResultBodyCell>
                                            </ResultRow>
                                        )
                                    }
                                    {
                                        (r.removed_bridges.length > 0) && (
                                            <ResultRow>
                                                {
                                                    r.low_flow.length === 0 && r.low_flow_ws === 0 && r.high_flow === 0 && (<ResultHeaderCell rowSpan={4} style={{width: HecRasHelper.getWidth(10), textAlign: 'left'}}>{r.name}</ResultHeaderCell>)
                                                }
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(25)}}><b>Removed Bridges</b></ResultBodyCell>
                                                <ResultBodyCell style={{width: HecRasHelper.getWidth(45)}}>{r.removed_bridges.filter(filterItem).map(renderItem).join(', ')}</ResultBodyCell>
                                            </ResultRow>
                                        )
                                    }
                                </>
                            )
                        })
                    }
                </ResultBody>
            </ResultTable>
        </>
    )
}